"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInput = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var InputMask_1 = __importDefault(require("./PhoneField/InputMask"));
var GenericInput = function (_a) {
    var value = _a.value, label = _a.label, _b = _a.error, error = _b === void 0 ? false : _b, errorText = _a.errorText, onFocus = _a.onFocus, onBlur = _a.onBlur, component = _a.component, inputProps = __rest(_a, ["value", "label", "error", "errorText", "onFocus", "onBlur", "component"]);
    var _c = (0, react_1.useState)(value ? true : false), activeLabel = _c[0], setActiveLabel = _c[1];
    var focusHandler = function (e) {
        setActiveLabel(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    var blurHandler = function (e) {
        if (!value) {
            setActiveLabel(false);
        }
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    return (react_1.default.createElement(Container, null,
        label && (react_1.default.createElement(StyledLabel, { "$isActive": activeLabel, "$isError": error }, label)),
        component ? (component(__assign({ $isError: error, value: value, onFocus: focusHandler, onBlur: blurHandler }, inputProps))) : (react_1.default.createElement(exports.StyledInput, __assign({ "$isError": error, value: value, onFocus: focusHandler, onBlur: blurHandler }, inputProps))),
        error && errorText && react_1.default.createElement(ErrorText, null, errorText)));
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin-top: 36px;\n  margin-bottom: 40px;\n"], ["\n  position: relative;\n  margin-top: 36px;\n  margin-bottom: 40px;\n"])));
var StyledLabel = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  font-size: 15px;\n  color: ", ";\n  transition: 0.2s;\n  pointer-events: none;\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  font-size: 15px;\n  color: ", ";\n  transition: 0.2s;\n  pointer-events: none;\n\n  ", "\n\n  ", "\n"])), function (p) { return p.theme.colors.grayB; }, function (p) {
    return p.$isActive &&
        "\n    color: ".concat(p.theme.colors.gray9, ";\n    transform: translateY(-100%) translateX(-10%) scale(0.8);\n  ");
}, function (p) {
    return p.$isError &&
        "\n    color: ".concat(p.theme.colors.danger, "; \n  ");
});
exports.StyledInput = styled_components_1.default.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: none;\n  padding: 0px;\n  outline: none;\n  width: 100%;\n  border-bottom: 2px solid ", ";\n  padding-top: 3px;\n  padding-bottom: 6px;\n  font-size: 14px;\n  transition: 0.2s;\n\n  ", "\n"], ["\n  border: none;\n  padding: 0px;\n  outline: none;\n  width: 100%;\n  border-bottom: 2px solid ", ";\n  padding-top: 3px;\n  padding-bottom: 6px;\n  font-size: 14px;\n  transition: 0.2s;\n\n  ", "\n"])), function (p) { return p.theme.colors.grayLight; }, function (p) {
    return p.$isError &&
        "\n    border-bottom-color: ".concat(p.theme.colors.danger, "; \n  ");
});
var StyledPhoneInput = exports.StyledInput.withComponent(InputMask_1.default);
var ErrorText = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 80%;\n  margin-top: 6px;\n  color: ", ";\n"], ["\n  font-size: 80%;\n  margin-top: 6px;\n  color: ", ";\n"])), function (p) { return p.theme.colors.danger; });
exports.default = GenericInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
